import React from "react";
import { Modal, Button } from "react-bootstrap";

const RestartModal = ({ show, handleClose, handleConfirm }) => {
  return (
    <Modal show={show} onHide={handleClose}>
      <Modal.Header closeButton>
        <Modal.Title>Confirm Restart</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        Confirm if you'd like to restart this conversation?
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={handleClose}>
          Cancel
        </Button>
        <Button variant="primary" onClick={handleConfirm}>
          Confirm
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default RestartModal;
